import React, { useEffect, useState } from "react";
import FingerLimitsEmployeeTable from "./components/FingerLimitsEmployeeTable";
import EditEmployee from "./modals/EditEmployee";
import ViewEmployee from "./modals/ViewEmployee";
import FilterEmployee from "./modals/FilterEmployee";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import axios from "axios";
import { updateObject } from "../../../helpers/updateObject";
import CreateEmployee from "./modals/CreateEmployee";
import {
  Tooltip
} from "@material-ui/core";
import PlusIcon from '@material-ui/icons/Add'
import { useSelector } from "react-redux";

function FingerLimit(props) {
  const [fingerLimits, setFingerLimits] = useState([]);
  const [chooseFingerLimitId, setChooseFingerLimitId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteFingerLimitsIds, setDeleteFingerLimitsIds] = useState([]);
  const [showView, setShowView] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [filterInputs, setFilterInputs] = useState({
    middleName: "",
    name: "",
    surname: "",
    pin: ""
  });
  const toggleDrawer = (open) => (event) => {
    setShowView(open);
  };

  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onFingerLimits = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
      middleName,
      name,
      surname,
      pin
    } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}employee/limit?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${middleName ? `&middleName=${middleName}` : ""}${name ? `&name=${name}` : ""}${pin ? `&pin=${pin}` : ""}&source=SAP${surname ? `&surname=${surname}` : ""}`)
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
        setFingerLimits(content);
        setIsError(false);
        setCount(totalElements)
      })
      .catch(() => {
        setIsLoading(false);
        setFingerLimits([]);
        setIsError(true);
      });
  };

  const onFingerLimitChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}employee/limit/${id}`,);
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onFingerLimits(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);

  const permissionList = useSelector(state => state.auth.permissionList)

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center ">
        {permissionList.some(element => element === "create_limit") &&

          <Tooltip title="Əlavə et" placement="top">
            <button
              className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle flex-shrink-0"
              onClick={() => setShowCreate(true)}
            >
              <PlusIcon />
            </button>
          </Tooltip>}
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className="ml-auto mb-0"
        />

      </div>

      <FingerLimitsEmployeeTable
        fingerLimits={fingerLimits}
        isLoading={isLoading}
        isError={isError}
        setChooseFingerLimitId={setChooseFingerLimitId}
        setOpenView={toggleDrawer(true)}
        setShowEdit={setShowEdit}
        setDeleteFingerLimitsIds={setDeleteFingerLimitsIds}
        deleteFingerLimitsIds={deleteFingerLimitsIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setShowCreate={setShowCreate}
      />

      {showView && (
        <ViewEmployee
          open={showView}
          onClose={toggleDrawer(false)}
          onFingerLimitChoose={onFingerLimitChoose}
          chooseFingerLimitId={chooseFingerLimitId}
        />
      )}

      {showEdit && (
        <EditEmployee
          show={showEdit}
          onHide={setShowEdit}
          onFingerLimits={onFingerLimits}
          id={chooseFingerLimitId}
          onFingerLimitChoose={onFingerLimitChoose}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}

        />
      )}
      {showCreate && (
        <CreateEmployee
          show={showCreate}
          onHide={setShowCreate}
          onFingerLimits={onFingerLimits}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
        />
      )}

      <FilterEmployee
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}

      />
    </div>
  );
}

export default FingerLimit;
